import { resource, RequestConfig } from '../helper/resource';

/**
 * 检查可用余额与起购/追加金额规则
 */
export function checkBalanceUsingPOST(
  req: CheckBuyRuleParam | void,
  config?: RequestConfig
): Promise<ApiResultboolean> {
  return resource.post('/LcProfitProof/checkBalance', req, config);
}

/**
 * 检查待签署合同是否完备
 */
export function checkContractNumUsingPOST(
  req: LcProfitProofParam | void,
  config?: RequestConfig
): Promise<ApiResultboolean> {
  return resource.post('/LcProfitProof/checkContractNum', req, config);
}

/**
 * 获取客户待签署合同列表
 */
export function signedListUsingPOST(
  req: LcProfitProofParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcSypzClientContract> {
  return resource.post('/LcProfitProof/client/signedList', req, config);
}

/**
 * 获取客户待签署合同列表
 */
export function toSignListUsingPOST(
  req: LcProfitProofParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcSypzClientContract> {
  return resource.post('/LcProfitProof/client/toSignList', req, config);
}

/**
 * 个人/机构客户签署合同
 */
export function signUsingPOST(req: CreateSignParam | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/LcProfitProof/contract/sign', req, config);
}

/**
 * 获取收益凭证详情
 */
export function queryDetailInfoUsingPOST(
  req: LcProfitProofParam | void,
  config?: RequestConfig
): Promise<ApiResultLcProfitProofDetailDto> {
  return resource.post('/LcProfitProof/queryDetailInfo', req, config);
}

/**
 * 获取挂钩标的行情
 */
export function queryRelateStockUsingPOST(
  req: LcQtIndexHisReqParam | void,
  config?: RequestConfig
): Promise<ApiResultListLcQtIndexHisDto> {
  return resource.post('/LcProfitProof/queryRelateStock', req, config);
}

/**
 * 查询已签署合同
 */
export function getSignedContractUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultListLcSypzSignedContractDto> {
  return resource.post('/LcProfitProof/signedContract', req, config);
}

/**
 * 测试删除签章
 */
export function uploadUsingPOST(req: LcProfitProofParam | void, config?: RequestConfig): Promise<string> {
  return resource.post('/LcProfitProof/test5', req, config);
}
